import { make } from 'vuex-pathify';
import axios from "axios";
import { triggerError } from "@/components/helpers/error-handler";

const timeout = 600000; //10 minutes

const getDefaultState = () => {
  return {
    dashboard: {},
    dashboardUpdated: null
  }
}

const state = getDefaultState();

const actions = {
  async getDashboard({ state, commit }) {
    try {
      const time = new Date().getTime();

      if (state.dashboardUpdated && time - state.dashboardUpdated < timeout) {
        return true;
      }

      const { data } = await axios({
        url: process.env.VUE_APP_API_URL + "dashboard"
      });

      commit('store_dashboard', { data, time });

      return true;
    } catch (error) {
      return triggerError(error);
    }
  },
  resetDashboardState ({ commit }) {
    commit('resetState')
  },
};

const mutations = {
  ...make.mutations(state),
  store_dashboard(state, {data, time}) {
    state.dashboard = data;
    state.dashboardUpdated = time;
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
};

const getters = {
  ...make.getters(state)
};

export const dashboard = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
